export default {
    "prompt":"prompt",
    "mainMenu":"mainMenu",
    "leadGate":"leadGate",
}